import { useState } from 'react'
import { X } from 'lucide-react'
import { Checkbox } from '@neo/primitives/checkbox'
import { Tooltip } from '@neo/primitives/tooltip'

interface ToastContentProps {
  description: string
  id: string
  onCheckboxChange: (checked: boolean) => void
  showDoNotShowAgain?: boolean
  onClose: () => void
  showCloseButton?: boolean
}

export const ToastContent = ({
  description,
  id,
  onCheckboxChange,
  showDoNotShowAgain = false,
  onClose,
  showCloseButton = true,
}: ToastContentProps) => {
  const [isChecked, setIsChecked] = useState(false)

  const handleChange = (checked: boolean) => {
    setIsChecked(checked)
    onCheckboxChange(checked)
  }

  return (
    <div className="flex flex-col gap-2" data-testid={`toast-${id}`}>
      {showCloseButton && (
        <Tooltip content="Dismiss">
          <button
            onClick={onClose}
            type="button"
            className="absolute -right-[8px] p-0.5 -top-[8px] bg-primary-foreground rounded-full border border-st2 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            data-testid={`button-${id}-close`}
          >
            <X className="size-[12px]" />
            <span className="sr-only">Close</span>
          </button>
        </Tooltip>
      )}
      <div>{description}</div>
      {showDoNotShowAgain && (
        <div className="flex items-center space-x-2 mt-2">
          <Checkbox
            id={`${id}-do-not-show-again`}
            name={`${id}-do-not-show-again`}
            label="Do not show this again"
            className="text-xs-400 text-muted-foreground"
            value={isChecked}
            onChange={handleChange}
            data-testid={`checkbox-${id}-do-not-show-again`}
          />
        </div>
      )}
    </div>
  )
}
